import { Badge as MuiBadge } from '@mui/material';
import type { BadgeProps as MuiBadgeProps } from '@mui/material/Badge';

export type BadgeProps = MuiBadgeProps;

export const Badge = ({ ...rest }: BadgeProps): JSX.Element => <MuiBadge {...rest} />;
